var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rectangle-wrap",class:_vm.nones==1&&'wrap',style:({background:_vm.bgColor})},[_vm._t("default"),_c('div',{staticClass:"big-circle"}),_c('div',{staticClass:"middle-circle"}),_c('div',{staticClass:"small-circle"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }